import { render, staticRenderFns } from "./LegislacaoEstadual.vue?vue&type=template&id=2feff8dc&scoped=true&"
import script from "./LegislacaoEstadual.vue?vue&type=script&lang=js&"
export * from "./LegislacaoEstadual.vue?vue&type=script&lang=js&"
import style0 from "./LegislacaoEstadual.vue?vue&type=style&index=0&id=2feff8dc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2feff8dc",
  null
  
)

export default component.exports